import Alpine from "alpinejs";
window.Alpine = Alpine;

import xDatasFxEvents from "./alpine-datas/xDatasFxEvents";
import xDatasNavigation from "./alpine-datas/xDatasNavigation";
import CartDrawer from "./alpine-datas/CartDrawer";

// MODULES
import BrowserDetection from "./base/detection.js";
import Env from "./base/env.js";
import Toolbox from "./base/toolbox.js";
import Channels from "./base/channels.js";
import MainTransition from "./transition/TransitionMain";
import UI from "./view/ui.js";

//? components
// import { EmbraceTheFlame } from "./base/Nexus";
// import * as modules from "./ModulesLoader";

import * as modulesGlobal from "./ModulesLoaderGlobal";
import loadComponents from "gia/loadComponents";

import config from "gia/config";
config.set("log", false); // disables unnecessary console.log calls

document.addEventListener("DOMContentLoaded", function () {
  //? Starter
  Env.framework.toolbox = new Toolbox();
  new BrowserDetection();
  var windowWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    clearTimeout(window.resizedFinished);
    // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
    if (window.innerWidth != windowWidth) {
      // Update the window width for next time
      windowWidth = window.innerWidth;
      // Do stuff here
      window.resizedFinished = setTimeout(function () {
        Channels.emit("window::smartresize");
      }, 100);
    }
  });

  detectEnvironment();

  //? Detect hashchange
  window.addEventListener("hashchange", function () {
    Channels.emit("window::hashchange");
  });

  //? Views
  Env.framework.UI = new UI();
  Env.framework.TRANSITIONS = new MainTransition();

  //! New Game +
  loadComponents(modulesGlobal);
  // EmbraceTheFlame(modules);

  //? Signature
  if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
    var args = [
      "\n %c with <3 by @jcsuzanne \u2730 http://www.jcsuzanne.com/ \n\n",
      "background: #DDA508; padding:5px 0;color: #333333;",
    ];
    window.console.log.apply(console, args);
  } else if (window.console) {
    window.console.log("@jcsuzanne - http://www.jcsuzanne.com/");
  }

  function detectEnvironment() {
    if (window.location.href.includes("http://127.0.0.1:9292")) {
      Env.$html.classList.add("local-env");
    }
  }

  //? PWA
  if (config.env === "production") {
    navigator.serviceWorker.controller
      ? console.log(
          "[PWA Builder] active service worker found, no need to register"
        )
      : navigator.serviceWorker
          .register(config.pathRoot + "pwa.js", { scope: config.pathRoot })
          .then(function (e) {
            console.log(
              "Service worker has been registered for scope:" + e.scope
            );
          });
  }
});
Alpine.start();
